import { IFormRules } from '@app/components/form/services';
import { IPopupOptions } from '@app/components/popup';
import { BehaviorSubject } from '@shared/rx';
import { ObjectId } from '../entities';

export interface IAuditLogItem {
  start: number;
  end: number;
}

export interface ISWItemViewAudit {
  manager_begin: IAuditLogItem;
  gratis: IAuditLogItem;
  spoilage: IAuditLogItem;
  adjustment: IAuditLogItem;
  end: IAuditLogItem;
  gratis_post_closure: IAuditLogItem;
  ingredient_spoil_post_closure: IAuditLogItem;
}

export interface IStandWorkSheetItemItemViewAuditLog extends ISWItemViewAudit {
  date: string;
  operator: IEntityFilterItem;
}
export interface IUpdatedFieldsMap {
  [key: string]: string[];
}

export interface IStandWorkSheetItemUpdatedFieldsMap extends IUpdatedFieldsMap {
  'stand-work-sheet-item': string[];
  'stand-work-sheet': string[];
}

export interface IInventoryCountItemUpdatedFieldsMap extends IUpdatedFieldsMap {
  'inventory-count-item': string[];
}

export interface IInventoryCountItemItemViewAuditLog {
  date: string;
  operator: IEntityFilterItem;
  measure: string;
  count: string;
  isNotLeaf: boolean;
  isLast: boolean;
}

export interface IInventoryCountItemCount {
  measure_description: string;
  measure_entity_id: string;
  count: {
    $numberDecimal: string;
  };
  factor_value: number;
  i18n?: {
    [key: string]: {
      measure_description: string;
    };
  };
}

export interface IInventoryCountMeasureAuditLogItem {
  start: {
    description: string;
    factorValue: string;
  };
  end: {
    description: string;
    factorValue: string;
  };
  isRemoved: boolean;
}

export interface IStandWorkSheetItemViewAuditLog {
  date: string;
  operator: IEntityFilterItem;
  previous: number;
  changed: number;
}

export interface IEntityFilterItem {
  text: string;
  value: string;
}

export interface IAuditLog {
  _id: string;
  operation: EAUDIT_LOG_OPERATION;
  date: string;
  document_id: string;
  userFriendlyDate?: string;
  person_name?: string;
  viewOperationName?: string;
  info: {
    person_id?: string;
    previousFields?: { [key: string]: any };
    updatedFields?: { [key: string]: any };
    removedFields?: { [key: string]: any };
    fullDocument?: { [key: string]: any };
  };
}

export enum EAUDIT_LOG_OPERATION {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  REVERT = 'revert',
}

export interface IDocumentInfo {
  [key: string]: any;
}

export interface IAuditTrailTempOptions {
  [key: string]: any;
}

export interface IAtFilter {
  search: string;
}

export interface IAuditTrailFormRule extends IPopupOptions {
  formRules: IFormRules;
  schema: ISchema;
}

export interface ISchema {
  [key: string]: any;
}

export interface IAuditTrailFormRules {
  [key: string]: IAuditTrailFormRule;
}

export interface IAuditTrailData {
  id: ObjectId;
  name: string;
  data: IStandWorkSheetItemItemViewAuditLog[];
  isFetched: boolean;
  isFetching: BehaviorSubject<boolean>;
  user: BehaviorSubject<IEntityFilterItem[]>;
  isOpen: boolean;
  ignoreFilter?: boolean;
  title: string;
  type: string;
}
